module.exports = __webpack_public_path__ + "img/book-bg.49f9e628.svg";